export default "/images/skip-back.svg?81ad9f15ef0d6c32e4136678a1c0f81a";